import { ActionWithPayload } from 'app/helpers';
import { OrderCardNumber } from './tracking-page-number.model';
import { Action } from '@ngrx/store';

export enum TrackingPageNumbersTypes {
  FETCH_CARRIERS = '[Tracking Page Numbers] Fetch Carriers',
  SET_CARRIERS = '[Tracking Page Numbers] Set Carriers',
  ADD_TRACKING_PAGE_NUMBERS = '[Tracking Page Numbers] Add Tracking Page Numbers',
  FETCH_TRACKING_NUMBER_CHECKPOINTS = '[Tracking Page Numbers] Fetch Tracking Number Checkpoints',
  SET_TRACKING_NUMBER_CHECKPOINTS = '[Tracking Page Numbers] Set Tracking Page Number Checkpoints',
  OPEN_TRACKING_NUMBER_DETAILS = '[Tracking Page Numbers] Open Tracking Number Details',
  CLOSE_TRACKING_NUMBER_DETAILS = '[Tracking Page Numbers] Close Tracking Number Details',
  CLOSE_ALL_TRACKING_NUMBER_DETAILS = '[Tracking Page Numbers] Close All Tracking Number Details',
  OPEN_SIDEBAR_ITEM = '[Tracking Page Numbers] Open Sidebar Item',
  CLOSE_SIDEBAR_ITEM = '[Tracking Page Numbers] Close Sidebar Item',
  SELECT_TRACKING_NUMBER = '[Tracking Page Numbers] Select Tracking Number',
  UPDATE_REVIEW = '[Tracking Page Numbers] Update Review',
  SHOW_MORE = '[Tracking Page Numbers] Show More',
  FETCH_SIDEBAR_ITEMS = '[Tracking Page Numbers] Fetch Sidebar Items',
  SET_SIDEBAR_ITEMS = '[Tracking Page Numbers] Set Sidebar Items',
  LOAD_MORE_TRACKING_NUMBERS = '[Tracking Page Numbers] Load More Tracking Numbers',
  SET_MORE_TRACKING_NUMBERS = '[Tracking Page Numbers] Set More Tracking Numbers'
}

export class SetCarriers implements ActionWithPayload<any[]> {
  public readonly type = TrackingPageNumbersTypes.SET_CARRIERS;
  constructor(public payload: any[]) {}
}

export class FetchTrackingNumberCheckpoints
  implements ActionWithPayload<string> {
  public readonly type =
    TrackingPageNumbersTypes.FETCH_TRACKING_NUMBER_CHECKPOINTS;
  constructor(public payload: string) {}
}

export interface SetTrackingNumberCheckpointsPayload {
  id: string;
  checkpoints: any[];
  orderId: string;
}
export class SetTrackingNumberCheckpoints
  implements ActionWithPayload<SetTrackingNumberCheckpointsPayload> {
  public readonly type =
    TrackingPageNumbersTypes.SET_TRACKING_NUMBER_CHECKPOINTS;
  constructor(public payload: SetTrackingNumberCheckpointsPayload) {}
}
export interface OpenTrackingNumberDetailsPayload {
  id: string;
  orderId: string;
}
export class OpenTrackingNumberDetails
  implements ActionWithPayload<OpenTrackingNumberDetailsPayload> {
  public readonly type = TrackingPageNumbersTypes.OPEN_TRACKING_NUMBER_DETAILS;
  constructor(public payload: OpenTrackingNumberDetailsPayload) {}
}

export class CloseTrackingNumberDetails implements ActionWithPayload<string> {
  public readonly type = TrackingPageNumbersTypes.CLOSE_TRACKING_NUMBER_DETAILS;
  constructor(public payload: string) {}
}

export class CloseAllTrackingNumberDetails implements Action {
  public readonly type =
    TrackingPageNumbersTypes.CLOSE_ALL_TRACKING_NUMBER_DETAILS;
}

export class OpenSidebarItem implements ActionWithPayload<any> {
  public readonly type = TrackingPageNumbersTypes.OPEN_SIDEBAR_ITEM;
  constructor(public payload: any) {}
}

export class CloseSidebarItem implements ActionWithPayload<any> {
  public readonly type = TrackingPageNumbersTypes.CLOSE_SIDEBAR_ITEM;
  constructor(public payload: any) {}
}

interface AddTrackingPageNumbersPayload {
  items: OrderCardNumber[];
  totalItems: number;
}
export class AddTrackingPageNumbers
  implements ActionWithPayload<AddTrackingPageNumbersPayload> {
  public readonly type = TrackingPageNumbersTypes.ADD_TRACKING_PAGE_NUMBERS;
  constructor(public payload: AddTrackingPageNumbersPayload) {}
}

export class SelectTrackingNumber implements ActionWithPayload<any> {
  public readonly type = TrackingPageNumbersTypes.SELECT_TRACKING_NUMBER;
  constructor(public payload: any) {}
}

export class UpdateReview implements ActionWithPayload<any> {
  public readonly type = TrackingPageNumbersTypes.UPDATE_REVIEW;
  constructor(public payload: any) {}
}

export class FetchSidebarItems implements ActionWithPayload<any> {
  public readonly type = TrackingPageNumbersTypes.FETCH_SIDEBAR_ITEMS;
  constructor(public payload: any) {}
}

export class ShowMore implements Action {
  public readonly type = TrackingPageNumbersTypes.SHOW_MORE;
}

export interface SidebarItemsResponse {
  items: any[];
  totalItems: number;
}
export class SetSidebarItems
  implements ActionWithPayload<SidebarItemsResponse> {
  public readonly type = TrackingPageNumbersTypes.SET_SIDEBAR_ITEMS;
  constructor(public payload: SidebarItemsResponse) {}
}

export class LoadMoreTrackingNumbers implements Action {
  public readonly type = TrackingPageNumbersTypes.LOAD_MORE_TRACKING_NUMBERS;
}

export class SetMoreTrackingNumbers
  implements ActionWithPayload<SidebarItemsResponse> {
  public readonly type = TrackingPageNumbersTypes.SET_MORE_TRACKING_NUMBERS;
  constructor(public payload: SidebarItemsResponse) {}
}

export type TrackingPageNumbersActions =
  | SetCarriers
  | FetchTrackingNumberCheckpoints
  | SetTrackingNumberCheckpoints
  | OpenTrackingNumberDetails
  | OpenSidebarItem
  | CloseSidebarItem
  | AddTrackingPageNumbers
  | SelectTrackingNumber
  | UpdateReview
  | CloseTrackingNumberDetails
  | CloseAllTrackingNumberDetails
  | ShowMore
  | SetSidebarItems
  | LoadMoreTrackingNumbers
  | SetMoreTrackingNumbers;
